<template>
	<sui-form @submit.prevent>
		<sui-form-field>
			<label v-if="!sinTitulo" :class="{ [$style.titulo]: true, [$style.boldFont]: true }">
				{{
				titulo
				}}
			</label>
			<sui-dropdown
				ref="select"
				v-model="plan"
				fluid
				:class="{ 'disabled': disabled }"
				:options="optionsPlanes"
				:placeholder="placeholder"
				:value="plan"
				selection
				search
				:loading="getLoadingActivos"
				:no-results-message="mensajeVacio"
				@input="onInput"
				@change="onChange"
			/>
			<div style="margin-top: 5px;">
				<span v-show="error" :class="$style.danger">
					<sui-icon name="exclamation circle" />{{mensajeError}}
				</span>
			</div>
		</sui-form-field>
	</sui-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	props: {
		placeholder: {
			type: String,
			default: 'Selecciona un plan'
		},
		titulo: {
			type: String,
			default: 'Plan'
		},
		mensajeVacio: {
			type: String,
			default: 'No se encontraron planes'
		},
		mensajeError:{
			type: String,
			default: 'Dato obligatorio'
		},
		error: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		claveCarrera: {
			type: String,
			default: ''
		},
		selected: {
			type: String,
			default: null
		},
		sinTitulo:{
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			plan: null
		};
	},

	computed: {
		...mapGetters('planes', ['getPlanesActivos', 'getLoadingActivos']),
		optionsPlanes: function() {
			return this.getPlanesActivos.map((p, indx) => ({
				text: `${p.clavePlan} - ${p.nombrePlan}`,
				value: indx,
				key: p.clavePlan
			}));
		},
		indx() {
			return this.optionsPlanes.findIndex((x) => x.key === this.selected);
		}
	},
	watch: {
		claveCarrera: function(val) {
			this.limpiarPlanesActivos();
			if (val && val !== 'undefined' && val !== '') {
                this.inicializarPlanesActivos(val);
                this.plan = null;
                this.$emit('input', null);
			}
		},
		selected: function(val) {
			if (val && this.index !== -1) {
				this.setSelected();
			}
		},
		getLoadingActivos: function(val) {
			if (!val && this.indx !== -1) {
				this.setSelected();
			}
		}
	},
	methods: {
		...mapActions('planes', [
			'inicializarPlanesActivos',
			'limpiarPlanesActivos'
		]),
		onChange(value) {
			this.$refs.select.filter = '';
			this.$emit('change', this.getPlanesActivos[value]);
		},
		onInput(val) {
			this.$emit('input', this.getPlanesActivos[val]);
		},
		setSelected() {
			this.plan = this.indx;
			this.$emit('input', this.getPlanesActivos[this.indx]);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.titulo {
	font-size: 14px !important;
	color: #5c5d5d !important;
}
.danger {
	color: #9f2241 !important;
}
</style>
